import { useCallback, useLayoutEffect, useRef } from "react";

const read = key => {
  try {
    const value = Number(sessionStorage.getItem(key));
    return Number.isFinite(value) && value >= 0 ? value : 0;
  } catch { return 0; }
};
const write = (key, value) => { if (key) { try { sessionStorage.setItem(key, String(value)); } catch { /* Navigation works when storage is unavailable. */ } } };

/** Restore only this user's sidebar, and reveal an off-screen active row minimally. */
export default function useSidebarScroll(scope, activePath) {
  const ref = useRef(null), position = useRef(0);
  const key = scope ? `bd_sidebar_scroll:v1:${encodeURIComponent(scope)}` : "";
  useLayoutEffect(() => {
    const node = ref.current;
    position.current = key ? read(key) : 0;
    if (node) node.scrollTop = position.current;
    // Keep the last observed position: a hidden Suspense tree may report zero.
    return () => write(key, position.current);
  }, [key]);
  useLayoutEffect(() => {
    const node = ref.current, active = node?.querySelector('[aria-current="page"]');
    if (!active || node.clientHeight <= 0) return;
    const viewport = node.getBoundingClientRect(), row = active.getBoundingClientRect();
    if (row.height <= 0) return;
    if (row.top < viewport.top) node.scrollTop += row.top - viewport.top;
    else if (row.bottom > viewport.bottom) node.scrollTop += row.bottom - viewport.bottom;
    position.current = node.scrollTop;
    write(key, position.current);
  }, [key, activePath]);
  const remember = useCallback(event => {
    const node = event.currentTarget;
    if (node.clientHeight <= 0 || !Number.isFinite(node.scrollTop) || node.scrollTop < 0) return;
    position.current = node.scrollTop;
    write(key, position.current);
  }, [key]);
  return { ref, onScroll: remember, onClickCapture: remember };
}
